<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header @change="_search" hint="Ketik no. invoice" />
            <div class="content">
                <div class="container">
                <!-- Page title -->
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Report Driver</h2>
                            </div>
                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto">
                                        <button
                                        class="btn btn-info ml-3"
                                        v-html="loading ? spin() : ic('refresh')"
                                        @click="_get"
                                        :disabled="loading"
                                        ></button>
                                        <button
                                        class="btn btn-white ml-3"
                                        v-html="ic('filter')"
                                        @click="_filter"
                                        ></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <b-nav tabs>
                            <b-nav-item>
                                <router-link to="../distribution-plan/data"> 
                                Daftar Service Level
                                </router-link>
                            </b-nav-item>
                            <b-nav-item active>
                                <router-link to="../distribution-plan">
                                Report Driver
                                </router-link>
                            </b-nav-item>
                            <b-nav-item>
                                <router-link to="../distribution-plan/jadwal">
                                Daftar Jadwal Pengiriman
                                </router-link>
                            </b-nav-item>
                            <b-nav-item>
                                <router-link to="../distribution-plan/jadwal">
                                Repo
                                </router-link>
                            </b-nav-item>
                        </b-nav>
                    </div>

                    <div style="margin-top: 20px;">
                        <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="!loading"/>
                        <Nodata v-if="loading && data.length === 0"/>
                        <div class="box" v-if="loading && data.length > 0">
                            <div class="card">
                                <div class="table-respon sive">
                                    <table class="table table-vcenter table-hover card-table table-striped"> 
                                        <thead>
                                            <tr class="text-muted">
                                                <th>No</th>
                                                <th style="width: 28%;">Driver</th>
                                                <th>SKU</th>
                                                <th>Qty</th>
                                                <th>Pcs</th>
                                                <th style="text-align: center;">Total Qty/Pcs</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                        <tbody>
                                            <template v-for="(value, index) in data" > 
                                                <tr :key="index">
                                                    <td>{{index + 1}}</td>
                                                    <td >{{value.nama_driver}}</td>
                                                    <td>
                                                        <div  v-for="(detail,i) in value.details" :key="i">
                                                            <div>{{detail.kode_barang}}</div>
                                                            <hr v-if="i < value.details.length - 1" style="margin: 2px" />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div  v-for="(detail,i) in value.details" :key="i">
                                                            <div>{{detail.qty}}</div>
                                                            <hr v-if="i < value.details.length - 1" style="margin: 2px" />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div  v-for="(detail,i) in value.details" :key="i">
                                                            <div>{{detail.qty_pcs}}</div>
                                                            <hr v-if="i < value.details.length - 1" style="margin: 2px" />
                                                        </div>
                                                    </td>
                                                    <td style="text-align: center;">
                                                        {{value.total_qty}} / {{value.total_pcs}} 
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FilterReport
            :config.sync="filter.config"
            :initData="filter.data"
            :isSubmit.sync="filter.isSubmit"
            @submit="filter.action"
            />  
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FilterReport from "./modals/filter-report.vue";

export default {
    name: "DistribusiReportDriver",
    components: { FilterReport},
    data(){
        return {
            auth: {},
            animate: null,
            reload: 0,
            loading: false,
            data: [],
            filter: {
                config: { view: false, title: "Filter" },
                data: null,
                isSubmit: false,
                action: () => {},
            },
            dataFilter: {
                status: "",
                date: "", 
                drivers: [],
            },

        }
    },
    mixins: [helper],
    methods:{
        _search(keyword){
            this.dataFilter.keyword = keyword
        },
        _filter() {
            this.filter.config = { view: true, title: "Filter" };
            this.filter.action = (formData) => {
                for (const key in formData) {
                    this.dataFilter[key] = formData[key];
                }
                this._get(this.dataFilter);
            };
        },
        async _get(formData){
            this.loading = false;
            try {
                var res = await this.axios.get("distribusi_report/report/delivery_order",{params: formData})
                this.data = res.data
            } catch (e) {
                console.error(e);
            } 
            this.loading = true;
        },
    },
    // mounted(){
    //     this._get(this.dataFilter);
    // }
}
</script>
